import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate ,useLocation } from 'react-router-dom';
import Logo from './images/BB.png';
import Header from './components/Header';
import { useLanguage } from './language/LanguageContext';
import LanguageSelector from './language/LanguageSelector';
import { FaBars, FaTimes, FaUser, FaSignOutAlt, FaHome, FaClipboardList, FaBell } from 'react-icons/fa';
//import Vendor4 from './images/birlaLogo.png';
import HumanBox from './images/mobileHumanBox.png';
import Box from './images/box.png';
import {handleForegroundNotifications} from '../push-notifications'
import Snackbar from './components/Snackbar'; 
import Box3 from './images/box3.png';
import RFQ from './images/orderDetails_icons/counter_offer.png';
import Cement from './images/cem.jpg';
import Cash from './images/cash.png';
import { useNotification } from '../context/NotificationContext';

// Skeleton Loader Component
const HomeSkeleton = () => (
  <div className="animate-pulse p-4">
    {/* Header Skeleton */}
    <div className="flex justify-between items-center mb-6">
      <div>
        <div className="h-6 bg-gray-200 rounded w-48 mb-2"></div>
        <div className="h-4 bg-gray-200 rounded w-32"></div>
      </div>
    </div>

    {/* DigiStore Skeleton */}
    <div className="rounded-lg border border-[#E0D9D9] flex flex-row py-2 mb-4">
      <div className="w-32 h-48 bg-gray-300 mx-4"></div>
      <div className="flex-1 pr-4">
        <div className="h-6 bg-gray-200 rounded w-1/2 mb-2"></div>
        <div className="h-4 bg-gray-200 rounded w-3/4 mb-4"></div>
        <div className="h-10 bg-gray-200 rounded w-1/3"></div>
      </div>
    </div>

    {/* My Orders Skeleton */}
    <div className="mt-2 rounded-lg bg-[#CFE6ED] p-4 mb-4">
      <div className="h-5 bg-gray-200 rounded w-1/4 mb-2"></div>
      <div className="flex flex-row items-end">
        <div className="flex-1">
          <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2"></div>
        </div>
        <div className="w-16 h-16 bg-gray-300 rounded"></div>
      </div>
    </div>

    {/* Payments Skeleton */}
    <div className="mb-6 mt-2 rounded-lg bg-[#F0E2E2] p-4">
      <div className="h-5 bg-gray-200 rounded w-1/4 mb-2"></div>
      <div className="flex flex-row items-end">
        <div className="flex-1">
          <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2"></div>
        </div>
        <div className="w-22 h-22 bg-gray-300 rounded"></div>
      </div>
    </div>
  </div>
);
// Create a separate component for the order card with countdown
const OrderCard = ({ order, navigate }) => {
  const [countdown, setCountdown] = useState('');
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const calculateCountdown = () => {
      // Use quotation_date or createdAt from the order
      const orderTime = new Date(order.quotation_date || order.createdAt).getTime();
      const currentTime = new Date().getTime();
      const timeDiff = currentTime - orderTime;
      
      // 30 minutes in milliseconds
      const thirtyMinutes = 30 * 60 * 1000;
      
      if (timeDiff > thirtyMinutes) {
        setIsExpired(true);
        setCountdown('');
        return;
      }

      // Remaining time
      const remainingTime = thirtyMinutes - timeDiff;
      
      // Convert to minutes and seconds
      const minutes = Math.floor(remainingTime / (1000 * 60));
      const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
      
      // Format the countdown
      setCountdown(`${minutes}m ${seconds}sec`);
    };

    // Initial calculation
    calculateCountdown();

    // Set up an interval to update countdown every second
    const countdownInterval = setInterval(calculateCountdown, 1000);

    // Clean up interval
    return () => clearInterval(countdownInterval);
  }, [order.quotation_date || order.createdAt]);


  return (
    <div key={order.id} className="border rounded-lg p-4 hover:shadow-md transition-shadow">
      <div className="flex flex-col justify-between">
        <div className='flex flex-row justify-between items-center'>
            <p className="font-medium text-black">{order.orderNumber}</p>
                     <p className="text-[#524D4D] font-medium">{order.time}</p>
          </div>

               <div className='flex flex-row justify-between items-center'>
           <span className={`text-md px-2 py-1 rounded-md ${
              order.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
              order.status === 'accepted' ? 'bg-green-100 text-green-800' :
              'bg-red-100 text-red-800'
            }`}>
              {order.status.charAt(0).toUpperCase() + order.status.slice(1)}
            </span>
          {!isExpired && countdown && (
            <div className="text-red-500 font-medium text-sm">
              <span className='text-[#524D4D]'>Closes in: </span>{countdown}
            </div>
          )}
        </div>
      </div>
      
      <div className="font-medium mt-3 flex justify-end text-sm">
        <button 
          onClick={() => navigate(`/supplier/orderdetails`, { 
            state: { quotationId: order._id , vendor_id : order.vendor_id} 
          })} 
          className='text-xs rounded-md py-1 px-3 bg-[#DE1B52] text-white'
        >
          View Order Details
        </button>
      </div>
    </div>
  );
};


function Home() {
  const navigate = useNavigate();
const [isLoading, setIsLoading] = useState(true);
const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const { language } = useLanguage();
  const [menuOpen, setMenuOpen] = useState(false);
  const [userName, setUserName] = useState('');
  // cement category id 
  const [category, setCategory] = useState(null);
  console.log("Cement Category:", category);
    const [snackbarState, setSnackbarState] = useState({
    show: true,
    minimized: false
  });
const [error, setError] = useState(null);  
const { notifications, setNotifications } = useNotification();
//const [notifications, setNotifications] = useState([]);
  console.log("----notifications:------",notifications);
  const [snackbarQuotes , setSnackbarQuotes ] = useState([]);
  // Functions to control snackbar state
  const minimizeSnackbar = () => {
    setSnackbarState(prev => ({ ...prev, minimized: true }));
  };
  
  const expandSnackbar = () => {
    setSnackbarState(prev => ({ ...prev, minimized: false }));
  };
  
  const hideSnackbar = () => {
    setSnackbarState({ show: false, minimized: false });
  };

  useEffect(() => {
    fetchVendorCategories();
  }, [fetchUrl]);

const fetchVendorCategories = useCallback(async () => {
  const vendorData = JSON.parse(localStorage.getItem('vendorData')) || {};
    
  try {
    const response = await fetch(
      `${fetchUrl}product-category/get-productCategoriesBy-vendor_id?vendor_id=${vendorData.id}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': vendorData.token,
        },
      }
    );
    const result = await response.json();
    console.log('Vendor Categories:', result);
    
    if (result.success && Array.isArray(result.data)) {
      // Find the Cement category
      const cementCategory = result.data.find(category => 
        category.product_category_name === "Cement"
      );
      
      if (cementCategory) {
        setCategory(cementCategory);
      } else {
        console.warn('Cement category not found in vendor categories');
        setCategory(null); // or set to a default value
      }
    } else {
      console.error('Invalid response format or no data received');
      setCategory(null);
    }
  } catch (error) {
    console.error('Error fetching vendor categories:', error);
    setCategory(null); // Ensure category is set to null on error
    return [];
  }
}, [fetchUrl]);

// handleForegroundNotifications(setNotifications);

  // Content translations
  const content = {
    english: {
      welcomeBack: "Welcome Back,",
      home: "Home",
      orders: "Orders",
      profile: "Profile",
      logout: "Logout"
    },
    telugu: {
      welcomeBack: "తిరిగి స్వాగతం,",
      home: "హోమ్",
      orders: "ఆర్డర్లు",
      profile: "ప్రొఫైల్",
      logout: "లాగ్అవుట్"
    }
  };

  const t = content[language];

 useEffect(() => {
    // Simulate loading and fetch user data
    const fetchUserData = async () => {
      try {
        // Simulate network delay
        await new Promise(resolve => setTimeout(resolve, 1000));

        // Get user data from localStorage or API
        const vendorData = JSON.parse(localStorage.getItem('vendorData')) || {};
        
        if (!vendorData.name) {
          throw new Error('User data not found');
        }

        setUserName(vendorData.name || "User");
      } catch (err) {
        console.error('Error fetching user data:', err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, []);



    
 // Error handling component
  const ErrorDisplay = () => (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 text-center">
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        className="h-20 w-20 text-red-300 mb-4"
        fill="none" 
        viewBox="0 0 24 24" 
        stroke="currentColor"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
        />
      </svg>
      <h2 className="text-xl text-red-500 mb-4">
        {error || 'Unable to load user data'}
      </h2>
      <button 
        onClick={() => window.location.reload()}
        className="bg-[#F43042] text-white px-4 py-2 rounded-lg hover:bg-red-600 transition"
      >
        Retry
      </button>
    </div>
  );

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };


  return (
     <div className="flex flex-col min-h-screen bg-white">
      {/* Use the new Header component */}
       <nav className="sticky top-0 z-50 ">
      <Header />
</nav>
      {/* Welcome Message */}
   {/*   <div className='p-2 w-full flex justify-end'>
              <LanguageSelector />
            </div> */}

{/* Main Content */}

      {/* Conditional Rendering */}
      {isLoading ? (
        <HomeSkeleton />
      ) : error ? (
        <ErrorDisplay />
      ) : (
        <div className="mb-1 p-4">
          {/* Welcome Message */}
          <div className="mb-6">
            <h1 className="text-2xl font-medium text-gray-800">
              {t.welcomeBack} <span className="font-semibold text-[#D64541]">{userName}!</span>
            </h1>
            <p className='text-sm font-semibold text-[#817C7C]'>Manage your digital sales with ease</p>
          </div>

          {/* DigiStore Section */}
          <div className='rounded-lg border border-[#E0D9D9] flex flex-row py-2'>
            <img src={HumanBox} alt="Img" className='px-4 w-32 h-48 '/>
            <div className=' text-left flex flex-col '>
              <h1 className='py-2 text-2xl font-semibold text-[#D93025]'>DigiStore</h1>
              <p className='py-2 text-sm px-1 font-medium'>Manage your Digital Store by adding or deleting products.</p>
              <div className='py-4 flex justify-start w-full'>
                <button 
                  onClick={() => navigate('/supplier/mycategories')}   
                  className='px-4 py-1.5 bg-[#F43042] rounded-full text-white text-left'
                >
                  Manage
                </button>
              </div>
            </div>
          </div>


         {category?.product_category_name === "Cement" && (
  <div className='mt-2 rounded-lg bg-[#CFE6ED] p-4'>
    <h1 className="text-xl font-semibold mb-2">Update Daily Prices</h1>
    <div className="flex flex-row items-end">
      <div className='text-left flex flex-col justify-start items-start'>
<p className='text-[#524D4D]'>
  Kindly update prices of <span className="font-bold">Cement</span> products you sell.
</p>
        <button 
          onClick={() => navigate('/supplier/priceupdate', { 
            state: { 
              categoryData: category 
            } 
          })}
          className='mt-1 font-medium text-sm text-[#1A73E7] underline decoration-dotted underline-offset-4'
        >
          Update Prices
        </button>
      </div>
      <img src={Cement} alt="Order" className='w-14 h-12'/>
    </div>
  </div>
)}

      <div className='mt-2 rounded-lg bg-[#F0E2E2] p-4 relative'>
  <h1 className="text-xl font-semibold mb-2">RFQs</h1>

  <div className="flex flex-row items-end">
    
    <div className='text-left flex flex-col justify-start items-start'>
    <p className='text-[#524D4D]'>
  Check and Respond to all <br />
  <span className="font-bold">Request For Quotes</span>.
</p>

      <button 
        onClick={() => navigate('/supplier/rfqs')}
        className='font-medium text-sm text-[#1A73E7] underline decoration-dotted underline-offset-4'
      >
        View
      </button>
    </div>

    {/* FORCE IMAGE TO EXACT RIGHT SIDE */}
    <img 
      src={RFQ} 
      alt="Order" 
      className="w-24 h-16 absolute right-[-8px] "
    />

  </div>
</div>


          {/* My Orders Section */}
          <div className='mt-2 rounded-lg bg-[#CFE6ED] p-4'>
            <h1 className="text-xl font-semibold mb-2">My Orders</h1>
            <div className="flex flex-row items-end">
              <div className='text-left flex flex-col justify-start items-start'>
                <p className='text-[#524D4D]'>
                  <span className="font-bold">Track</span> and <span className="font-bold">Manage</span> all your orders in one place.
                  </p>       
                           <button 
                  onClick={() => navigate('/supplier/orders')}
                  className='font-medium text-sm text-[#1A73E7] underline decoration-dotted underline-offset-4'
                >
                  View
                </button>
              </div>
              <img src={Box3} alt="Order" className='w-15 h-15'/>
            </div>
          </div>

          {/* Payments Section */}
          <div className='mb-2 mt-2 rounded-lg bg-[#F0E2E2] p-4'>
            <h1 className="text-xl font-semibold mb-2">Payments</h1>
            <div className="flex flex-row items-end">
              <div className='text-left flex flex-col justify-start items-start'>
<p className='text-[#524D4D]'>
  <span className="font-bold">View</span> and <span className="font-bold">Manage</span> all payment transactions here.
</p>                <button className='font-medium text-sm text-[#1A73E7] underline decoration-dotted underline-offset-4'>
                  View
                </button>
              </div>
              <img src={Cash} alt="Order" className='w-22 h-22'/>
            </div>
          </div>
        </div>
      )}

      {/* Overlay when menu is open */}
      {menuOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={toggleMenu}
        ></div>
      )}


             <Snackbar 
                snackbarState={snackbarState}
                notifications={notifications}
                minimizeSnackbar={minimizeSnackbar}
                expandSnackbar={expandSnackbar}
                hideSnackbar={hideSnackbar}
            /> 
    </div>
  );
}

export default Home;
